module.exports = __webpack_public_path__ + "makerwpf946ba57b70fd906726b4bb8417c9afd.png";